import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isRequiredIf from 'react-proptype-conditional-require';
import Cross from '@deliveroo/icon-set/react/Cross';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import P from '@deliveroo/consumer-component-library/components/P';
import withPlaceholder from '@deliveroo/consumer-component-library/components/withPlaceholder';

import styles from './styles.scss';

function FilterTag({ label, onClose, isPlaceholder, placeholderClassName }) {
  return (
    <div
      className={classnames(styles.container, {
        [styles.placeholder]: isPlaceholder,
        [placeholderClassName]: isPlaceholder,
      })}
    >
      <P size="small" isBold spacing="0 small 0 0" color="white">
        {label}
      </P>
      {!isPlaceholder && (
        <button className={styles.iconWrapper} type="button" onClick={onClose}>
          <Icon component={Cross} color="white" size={18} spacing="0 0 0 0" />
        </button>
      )}
    </div>
  );
}

FilterTag.propTypes = {
  label: isRequiredIf(PropTypes.string, (props) => !props.isPlaceholder),
  onClose: isRequiredIf(PropTypes.func, (props) => !props.isPlaceholder),
  isPlaceholder: PropTypes.bool,
  placeholderClassName: PropTypes.string,
};

FilterTag.defaultProps = {
  label: undefined,
  onClose: undefined,
  isPlaceholder: false,
  placeholderClassName: '',
};

FilterTag.placeholderProps = {
  label: 'placeholder',
};

export default withPlaceholder(FilterTag);
